// Tiny shared "what's open on screen" context for the Deskte AI widget.
//
// The floating AI widget lives in the top bar and doesn't know which client or
// policy ficha the agent has open. The detail views set it here on mount and
// clear it on unmount; the AI reads it when the agent sends a message, so
// "modify THIS client/policy" works without naming them. Module-level (not React
// state) on purpose — it's read imperatively at send time, no re-render needed.

let _openClient = null;
let _openPolicy = null;

export function setAiOpenClient(c) {
  _openClient = c && c.id ? { id: c.id, name: c.name || '' } : null;
}

export function setAiOpenPolicy(p) {
  _openPolicy = p && p.id ? { id: p.id } : null;
}

export function getAiOpenContext() {
  return { openClient: _openClient, openPolicy: _openPolicy };
}
